import { render, staticRenderFns } from "./AlertPersistView.vue?vue&type=template&id=e9dea040"
import script from "./AlertPersistView.vue?vue&type=script&lang=ts"
export * from "./AlertPersistView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports